/**
 * Whitelist sanitization for URL parameters.
 * Fortify recommends whitelist regex validation as the most secure approach for XSS prevention.
 * @param {*} value - The value to sanitize
 * @param {RegExp} [pattern=/^[a-zA-Z0-9_-]*$/] - Allowed character whitelist regex
 * @returns {string} Validated string (empty string if validation fails)
 */
export function sanitizeParam(value, pattern = /^[a-zA-Z0-9_-]*$/) {
  // 处理 null/undefined
  if (value == null) {
    return '';
  }

  // 转换为字符串
  const convertedValue = String(value);

  // 使用正则表达式校验
  const isValid = pattern.test(convertedValue);

  return isValid ? convertedValue : '';
}

/**
 * Validate that a URL uses an allowed protocol (http/https).
 * Prevents javascript: and data: URL scheme injection (XSS).
 * @param {string} url - The URL to validate
 * @returns {string} The URL if valid, empty string otherwise
 */
export function sanitizeUrl(url) {
  if (typeof url !== 'string') return '';
  try {
    const parsed = new URL(url, window.location.origin);
    if (['http:', 'https:'].includes(parsed.protocol)) {
      return url;
    }
  } catch {
    // not a valid URL
  }
  return '';
}

/**
 * Sanitize cookie name/value to prevent header manipulation.
 * Removes CR, LF, and other characters that are dangerous in HTTP headers.
 * @param {string} value - The cookie name or value to sanitize
 * @returns {string} Sanitized string
 */
export function sanitizeCookieValue(value) {
  if (value == null) return '';
  return String(value).replace(/[\r\n\t;=]/g, '');
}
